module.exports = __webpack_public_path__ + "static/img/bg-ziti.5270723.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg-ziti.png
// module id = uky+
// module chunks = 0